const INITIAL_STATE = {
    data: null
}

const dadosRepresentanteReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'dadosRepresentante': {

            return {
                ...state,
                data: action.payload.dadosRepresentante
            }
        }
        default: {
            return state
        }
    }
}

export default dadosRepresentanteReducer